<template>
  <div class="d-flex align-items-center justify-content-center">
    {{ label }}
    <tooltip :text="tooltipText" style="margin-left: 4px;">
      <i class="fas fa-info-circle" style="font-size: 12px; color: #6c757d; margin-top: 5px;"></i>
    </tooltip>
  </div>
</template>

<script>
import Tooltip from "./Tooltip";

export default {
  name: "TableHeaderWithTooltip",
  components: { Tooltip },
  props: {
    label: {
      type: String,
      required: true
    },
    tooltipText: {
      type: String,
      required: true
    }
  }
}
</script>
